
let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container');
  if (apElements){
    $('.product-price').after($('#avpoptions-container'));
    clearInterval(interval);
  }
}, 100);

function forceQuitInterval(){
  clearInterval(interval);
}

setTimeout(forceQuitInterval, 10000)

// Start: Plus add charge into price of product
let formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

let originPriceText = null;
let originPrice = null;
let interval3 = setInterval(function () {
  let ap_elements = document.querySelector('#avpoptions-container');
  if (ap_elements) {
    if (!originPriceText) {
      originPriceText = $('#ProductPrice')[0].innerHTML;
      originPrice = parseFloat($('#ProductPrice')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
    }	
    if (originPriceText && originPrice && $('#avp-productoption-total-add').is(':visible')){
      let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('$', '').replace(/[^\d.]/g, ''));
      let newPrice = originPrice + addChargePrice;
      $('#ProductPrice')[0].innerHTML = formatter.format(newPrice);

    } else {
      $('#ProductPrice')[0].innerHTML = originPriceText;
    }
  } 
}, 100);
// End: Plus add charge into price of product